<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+learningUnitId" :endpoint-params="endpointParams"
            icon="laptop" :props="props" :map="map" :bus="bus"
            :title2="courseTitle" :title3="programTitle" :background-image="backgroundImage">
        </trax-ui-top-box>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-training-resource-edit-top-box'},
            programTitle: null,
            courseTitle: null,
            learningUnitId: null,
            backgroundImage: null
        },

        data: function() {
            var endpointParams = {};
            if (data.registration_id) endpointParams.registration_id = data.registration_id;
            return {
                endpoint: app_url+'polaris/api/front/learning-units',
                endpointParams: endpointParams,
                props: {
                    code: { source:'code' },
                    name: { source:'name' },
                    description: {source: 'description'}
                },
                map: {
                    title1: 'code',
                    description: 'description',
                    descriptionTitle: 'name',
                },
                bus: new Vue()
            }
        }

    }
</script>
